// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__uoMRB","activeTab":"styles_activeTab__hkZ6K"};